import React, { useState, useMemo, useEffect } from "react";
import SearchBox from "../input/searchBox/SearchBox";
import OptionInput from "../input/optionInput/OptionInput";
import JobTable, { RedCell } from "../table/JobTable";
import Dialog from "../dialog/Dialog";
import axios from "axios";
import { BASE_URL_2 } from "../../customHooks/config";
import { toast } from "react-toastify";
import Spinner from "../layout/loader/Spinner";
import { Link, useNavigate, useParams } from "react-router-dom";
import OptionInputReason from "../input/optionInput/OptionInputReason";
import { Tooltip as ReactTooltip } from "react-tooltip";

function AllJobsTab() {
  const { id } = useParams();
  const [value, setValue] = React.useState(Number(id) || 1);
  const [typeData, setTypeData] = useState([]);
  const [assigndata, setAssignData] = useState([]);
  const [jobCount, setJobCount] = useState({
    my_job_count: 0,
    new_job_count: 0,
    rejected_job_count: 0,
  });
  const [myJobData, setMyJobData] = useState({});
  const [newJobData, setNewJobData] = useState({});
  const [reNewJobData, setReNewJobData] = useState({});
  const [paginationData, setPaginationData] = useState({
    pageSize: 5,
    pageNumber: 1,
    next: false,
    previous: false,
    count: 0,
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  function handleChange(id) {
    setValue(id);
    setFilter({ ...filter });
    setPaginationData({
      ...paginationData,
      pageNumber: 1,
      status: "",
      pageSize: 5,
      next: false,
      previous: false,
      count: 0,
    });
    navigate(`/all-jobs/${id}`);
  }
  const [rowData, setRowData] = useState({});
  const [open, setOpen] = React.useState(false);
  const [rejection, setRejection] = useState({
    reasonDropDown: {},
    disabled: true,
    reasonTextBox: "",
  });
  const [loadingRejected, setLoadingRejected] = useState(false);
  const [loadingAccepted, setLoadingAccepted] = useState(false);
  const [filter, setFilter] = useState({});

  useEffect(() => {
    setValue(Number(id) || 1);
  }, [id]);

  const handleClickOpen = (row) => {
    setOpen(true);
    setRowData(row);
  };
  const handleClose = () => {
    setOpen(false);
    setRejection({
      ...rejection,
      reasonDropDown: {},
      disabled: true,
      reasonTextBox: "",
    });
  };
  // useEffect(()=>{
  // if(reason?.reason && reason?.reason?.id !== 7) setRejectDisabled(false);
  // else if(reason?.reason && reason?.reason?.id === 7 && rejectionReason)  setRejectDisabled(false);
  // },[reason])

  useEffect(() => {
    // let tabParam = "";
    // if (value === 1) tabParam = "ACCEPTED";
    // else if (value === 2) tabParam = "PENDING";
    // else if (value === 3) tabParam = "REJECTED";

    // setLoading(true);
    let url = `${BASE_URL_2}job/vendor/job_count/`;
    if (filter?.job_type?.id)
      url = `${BASE_URL_2}job/vendor/job_count/?&job_type_id=${filter?.job_type?.id}`;
    if (filter?.assign_by?.assigned_by)
      url = `${BASE_URL_2}job/vendor/job_count/?&assign_by=${filter?.assign_by?.assigned_by}`;
    if (filter?.companyName)
      url = `${BASE_URL_2}job/vendor/job_count/?&company_name=${filter?.companyName}`;
    if (filter?.assign_by?.assigned_by && filter?.job_type?.id)
      url = `${BASE_URL_2}job/vendor/job_count/?&job_type_id=${filter?.job_type?.id}&assign_by=${filter?.assign_by?.assigned_by}`;
    if (filter?.companyName && filter?.job_type?.id)
      url = `${BASE_URL_2}job/vendor/job_count/?&company_name=${filter?.companyName}&job_type_id=${filter?.job_type?.id}`;
    if (filter?.companyName && filter?.assign_by?.assigned_by)
      url = `${BASE_URL_2}job/vendor/job_count/?&company_name=${filter?.companyName}&assign_by=${filter?.assign_by?.assigned_by}`;
    if (
      filter?.companyName &&
      filter?.assign_by?.assigned_by &&
      filter?.job_type?.id
    )
      url = `${BASE_URL_2}job/vendor/job_count/?&company_name=${filter?.companyName}&job_type_id=${filter?.job_type?.id}&assign_by=${filter?.assign_by?.assigned_by}`;

    axios
      .get(url, { withCredentials: true })
      .then((res) => {
        // setLoading(false);
        if (res?.data?.success) {
          setJobCount({
            ...jobCount,
            my_job_count: res?.data?.data?.my_job_count,
            new_job_count: res?.data?.data?.new_job_count,
            rejected_job_count: res?.data?.data?.rejected_job_count,
          });
        } else {
          toast.error(res?.data?.error);
        }
      })
      .catch((err) => {
        // setLoading(false);
        toast.error(err?.data?.error);
      });
  }, [value, paginationData?.status, filter]);

  useEffect(() => {
    let tabParam = "";
    let pageNumber, pageSize;
    if (value === 1) tabParam = "ACCEPTED";
    else if (value === 2) tabParam = "PENDING";
    else if (value === 3) tabParam = "REJECTED";
    pageNumber = paginationData.pageNumber;
    pageSize = paginationData.pageSize;
    setLoading(true);
    let url = `${BASE_URL_2}job/vendor/job/?page=${pageNumber}&page_size=${pageSize}&status=${tabParam}`;
    if (filter?.job_type?.id)
      url = `${BASE_URL_2}job/vendor/job/?page=${pageNumber}&page_size=${pageSize}&status=${tabParam}&job_type_id=${filter?.job_type?.id}`;
    if (filter?.assign_by?.assigned_by)
      url = `${BASE_URL_2}job/vendor/job/?page=${pageNumber}&page_size=${pageSize}&status=${tabParam}&assign_by=${filter?.assign_by?.assigned_by}`;
    if (filter?.companyName)
      url = `${BASE_URL_2}job/vendor/job/?page=${pageNumber}&page_size=${pageSize}&status=${tabParam}&company_name=${filter?.companyName}`;
    if (filter?.assign_by?.assigned_by && filter?.job_type?.id)
      url = `${BASE_URL_2}job/vendor/job/?page=${pageNumber}&page_size=${pageSize}&status=${tabParam}&job_type_id=${filter?.job_type?.id}&assign_by=${filter?.assign_by?.assigned_by}`;
    if (filter?.companyName && filter?.job_type?.id)
      url = `${BASE_URL_2}job/vendor/job/?page=${pageNumber}&page_size=${pageSize}&status=${tabParam}&company_name=${filter?.companyName}&job_type_id=${filter?.job_type?.id}`;
    if (filter?.companyName && filter?.assign_by?.assigned_by)
      url = `${BASE_URL_2}job/vendor/job/?page=${pageNumber}&page_size=${pageSize}&status=${tabParam}&company_name=${filter?.companyName}&assign_by=${filter?.assign_by?.assigned_by}`;
    if (
      filter?.companyName &&
      filter?.assign_by?.assigned_by &&
      filter?.job_type?.id
    )
      url = `${BASE_URL_2}job/vendor/job/?page=${pageNumber}&page_size=${pageSize}&status=${tabParam}&company_name=${filter?.companyName}&job_type_id=${filter?.job_type?.id}&assign_by=${filter?.assign_by?.assigned_by}`;

    axios
      .get(url, { withCredentials: true })
      .then((res) => {
        setLoading(false);
        if (tabParam === "ACCEPTED") {
          setMyJobData(res?.data?.data);
          setPaginationData({
            ...paginationData,
            count: res?.data?.data?.count,
            next: res?.data?.data?.next ? true : false,
            previous: res?.data?.data?.previous ? true : false,
          });
        } else if (tabParam === "PENDING") {
          setNewJobData(res?.data?.data);
          setPaginationData({
            ...paginationData,
            count: res?.data?.data?.count,
            next: res?.data?.data?.next ? true : false,
            previous: res?.data?.data?.previous ? true : false,
          });
        } else {
          setReNewJobData(res?.data?.data);
          setPaginationData({
            ...paginationData,
            count: res?.data?.data?.count,
            next: res?.data?.data?.next ? true : false,
            previous: res?.data?.data?.previous ? true : false,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.data?.error);
      });
  }, [
    value,
    paginationData?.pageNumber,
    paginationData?.pageSize,
    paginationData?.status,
    filter,
  ]);

  const handleClickAccepted = (row) => {
    setLoadingAccepted(true);
    axios
      .post(
        `${BASE_URL_2}job/vendor/job/?job_id=${row.job_id}`,
        { status: "ACCEPTED" },
        { withCredentials: true }
      )
      .then((res) => {
        if (res?.data?.success) {
          toast.success(res?.data?.data?.message);
          setPaginationData({ ...paginationData, status: row.job_id });
        } else toast.error(res?.data?.data?.error);
        setLoadingAccepted(false);
      })
      .catch((err) => {
        toast.error(err?.data?.error);
        setLoadingAccepted(false);
      });
  };

  const handleClickRejected = () => {
    let res = null;
    if (rejection && rejection?.reasonDropDown?.id !== 7)
      res = rejection?.reasonDropDown?.reason;
    if (
      rejection &&
      rejection?.reasonDropDown?.id === 7 &&
      !rejection?.disabled &&
      rejection?.reasonTextBox
    )
      res = rejection?.reasonTextBox;
    if (res) {
      setLoadingRejected(true);
      axios
        .post(
          `${BASE_URL_2}job/vendor/job/?job_id=${rowData.job_id}`,
          { status: "REJECTED", reject_reason: res },
          { withCredentials: true }
        )
        .then((res) => {
          if (res?.data?.success) {
            toast.success(res?.data?.data?.message);
            setPaginationData({ ...paginationData, status: rowData.job_id });
          } else toast.error(res?.data?.data?.error);
          setLoadingRejected(false);
          handleClose();
        })
        .catch((err) => {
          toast.error(err?.data?.error);
          handleClose();
          setLoadingRejected(false);
        });
    }
  };

  useEffect(() => {
    axios
      .get(`${BASE_URL_2}/job/type/`)
      .then((res) => {
        setTypeData(res?.data?.data);
      })
      .catch((err) => {
        toast.error(err?.data?.error);
      });
  }, []);

  useEffect(() => {
    let tabParam = "";
    if (value === 1) tabParam = "ACCEPTED";
    else if (value === 2) tabParam = "PENDING";
    else if (value === 3) tabParam = "REJECTED";
    axios
      .get(`${BASE_URL_2}/job/vendor/job_assigned_by/?status=${tabParam}`, {
        withCredentials: true,
      })
      .then((res) => {
        setAssignData(res?.data?.data);
      })
      .catch((err) => {
        toast.error(err?.data?.error);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${BASE_URL_2}/job/type/`)
      .then((res) => {
        setTypeData(res?.data?.data);
      })
      .catch((err) => {
        toast.error(err?.data?.error);
      });
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "Job ID",
        width: 60,
        accessor: "job_id",
      },
      {
        Header: " Applicant",
        // accessor: "action",
        Cell: ({ row }) => (
          <div>
            <button
              className=" h-[34px] px-3  bg-white border border-[#2563EB] rounded-md text-sm text-[#2563EB] "
              onClick={() =>
                navigate(`/applicant/${row?.original?.job_id}`, {
                  state: {
                    companyName: row?.original?.company?.company_name,
                    jobTitle: row?.original?.job_title,
                  },
                })
              }
            >
              View ({row?.original?.job_applicant_count})
            </button>
          </div>
        ),
      },
      {
        Header: "Company Name",
        width: 150,
        // accessor: "company.company_name",
        Cell: ({ row }) => (
          <>
            <p data-tooltip-id={row?.original?.job_id}>
              {row?.original?.company?.company_name?.length > 30
                ? row?.original?.company?.company_name?.slice(0, 30)
                : row?.original?.company?.company_name}{" "}
              {row?.original?.company?.company_name?.length > 30 ? "...." : ""}
            </p>
            <ReactTooltip
              id={row?.original?.job_id}
              place="right"
              content={row?.original?.company?.company_name}
            />
          </>
        ),
      },
      {
        Header: "Job Title",
        width: 150,
        accessor: "job_title",
        Cell: ({ row }) => (
          <>
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              to={`/job-details/${row?.original?.job_id}`}
              target="_blank"
              state={{
                status: "ACCEPTED",
                create_time: row?.original?.create_time,
              }}
            >
              <p data-tooltip-id={row?.original?.job_title}>
                {row?.original?.job_title?.length > 30
                  ? row?.original?.job_title?.slice(0, 30)
                  : row?.original?.job_title}{" "}
                {row?.original?.job_title?.length > 30 ? "...." : ""}
              </p>
            </Link>
            <ReactTooltip
              id={row?.original?.job_title}
              place="right"
              content={row?.original?.job_title}
            />
          </>
        ),
        linkAccessor: "link",
      },
      {
        Header: "CTC/Stipend",
        width: 130,
        accessor: (row) => {
          if (row?.job_type_name === "Full Time Job") {
            let max = Number(String(row?.ctc_max).slice(0, 2));
            let min = Number(String(row?.ctc_min).slice(0, 2));
            max = (row?.ctc_max < 1000000) ? parseFloat(max / 10) : max;
            min = (row?.ctc_min < 1000000) ? parseFloat(min / 10) : min;

            return `₹ ${min} - ${max}  LPA`;
          } else {
            const stipend = row?.stipend ?? 0.0;
            return `₹ ${stipend}`;
          }
        },
      },
      {
        Header: "Location",
        width: 120,
        accessor: (row) => {
          if (row?.work_from_home) return "Work From Home";
          else return row?.job_location;
        },
        Cell: ({ value, row }) => {
          if (value === "Work From Home")
            return (
              <div
                onClick={() =>
                  window.open(`/job-details/${row?.original?.job_id}`, "_blank")
                }
              >
                Work From Home
              </div>
            );
          else if (Array.isArray(value) && value?.length === 1)
            return (
              <div
                onClick={() => navigate(`/job-details/${row?.original?.job_id}`)}
              >
                {value[0]?.city}
              </div>
            );
          else {
            return (
              <div
                onClick={() =>
                  window.open(`/job-details/${row?.original?.job_id}`, "_blank")
                }
              >
                {`${value[0]?.city} , ${value[1]?.city} + ${value?.length > 2 ? value?.length - 2 : ""
                  }`}
              </div>
            );
          }
        },
      },
      {
        Header: "Job Type",
        width: 120,
        accessor: "job_type_name",
      },
      {
        Header: "Job Status",
        width: 130,
        accessor: "job_status",
      },

      {
        Header: "Compensation  Type",
        width: 130,
        accessor: "compensation_type",
      },
      {
        Header: "Compensation",
        width: 130,
        accessor: "compensation",
      },

      {
        Header: "Projected Earning",
        width: 120,
        accessor: "projected",
        Cell: ({ value }) => (value === null ? 0 : `₹ ${value}`),
      },

      {
        Header: "Assign By",
        width: 130,
        accessor: "assigned_by",
      },

      {
        Header: "Accept Date",
        width: 130,
        accessor: "update_time",
      },
    ],
    []
  );

  const newJobcolumns = useMemo(
    () => [
      {
        Header: "Job ID",
        width: 60,
        accessor: "job_id",
      },
      {
        Header: "Job Title",
        width: 150,
        accessor: "job_title",
        Cell: ({ row }) => (
          <>
            <Link
              style={{ color: "#2563EB", textDecoration: "underline" }}
              to={`/job-details/${row?.original?.job_id}`}
              state={{
                status: "PENDING",
                create_time: row?.original?.create_time,
                job_status: row?.original?.job_status,
              }}
            >
              <p data-tooltip-id={row?.original?.job_title}>
                {row?.original?.job_title?.length > 30
                  ? row?.original?.job_title?.slice(0, 30)
                  : row?.original?.job_title}{" "}
                {row?.original?.job_title?.length > 30 ? "...." : ""}
              </p>
            </Link>
            <ReactTooltip
              id={row?.original?.job_title}
              place="right"
              content={row?.original?.job_title}
            />
          </>
        ),
        linkAccessor: "link",
      },
      {
        Header: "Company Name",
        width: 150,
        accessor: "company.company_name",
        Cell: ({ row }) => (
          <>
            <p data-tooltip-id={row?.original?.job_id}>
              {row?.original?.company?.company_name?.length > 30
                ? row?.original?.company?.company_name?.slice(0, 30)
                : row?.original?.company?.company_name}{" "}
              {row?.original?.company?.company_name?.length > 30 ? "....." : ""}
            </p>
            <ReactTooltip
              id={row?.original?.job_id}
              place="right"
              content={row?.original?.company?.company_name}
            />
          </>
        ),
      },
      {
        Header: "Job Type",
        width: 120,
        accessor: "job_type_name",
      },
      {
        Header: "Compensation  Type",
        width: 130,
        accessor: "compensation_type",
      },
      {
        Header: "Compensation",
        width: 130,
        accessor: "compensation",
      },

      {
        Header: "Projected Earning",
        width: 120,
        accessor: "projected",
        Cell: ({ value }) => (value === null ? 0 : `₹ ${value}`),
      },
      {
        Header: "CTC/Stipend",
        width: 130,
        accessor: (row) => {
          if (row.job_type_name === "Full Time Job") {
            let max = Number(String(row?.ctc_max).slice(0, 2));
            let min = Number(String(row?.ctc_min).slice(0, 2));
            max = (row?.ctc_max < 1000000) ? parseFloat(max / 10) : max;
            min = (row?.ctc_min < 1000000) ? parseFloat(min / 10) : min;

            return `₹ ${min} - ${max}  LPA`;
          } else {
            const stipend = row?.stipend ?? 0.0;
            return `₹ ${stipend}`;
          }
        },
      },
      {
        Header: "Location",
        width: 120,
        accessor: (row) => {
          if (row.work_from_home) return "Work From Home";
          else return row.job_location;
        },
        Cell: ({ value, row }) => {
          if (value === "Work From Home")
            return (
              <div
                onClick={() =>
                  window.open(`/job-details/${row?.original?.job_id}`, "_blank")
                }
              >
                Work From Home
              </div>
            );
          else if (Array.isArray(value) && value?.length === 1)
            return (
              <div
                onClick={() => navigate(`/job-details/${row?.original?.job_id}`)}
              >
                {value[0]?.city}
              </div>
            );
          else {
            return (
              <div
                onClick={() =>
                  window.open(`/job-details/${row?.original?.job_id}`, "_blank")
                }
              >
                {`${value[0]?.city} , ${value[1]?.city} + ${value?.length > 2 ? value?.length - 2 : ""
                  }`}
              </div>
            );
          }
        },
      },
      {
        Header: "Assign Date",
        width: 130,
        accessor: "create_time",
      },
      {
        Header: "Assign By",
        width: 130,
        accessor: "assigned_by",
      },
      {
        Header: " Action",
        // accessor: "action",
        Cell: ({ row }) => {
          if (row?.original?.job_status === "OPEN")
            return (
              <div>
                <button
                  className=" h-[34px] px-3 mr-2 bg-[#0DA06A] rounded-md text-sm text-white "
                  onClick={() => handleClickAccepted(row?.original)}
                >
                  {loadingAccepted ? <Spinner /> : "Accept"}
                </button>
                <button
                  onClick={() => {
                    handleClickOpen(row?.original);
                  }}
                  className=" h-[34px] px-3 border border-[#EF4444] rounded-md text-sm text-[#EF4444] "
                >
                  Reject
                </button>
              </div>
            );
          else
            return (
              <button
                // onClick={()=>{handleClickOpen(row.original)}}
                disabled={true}
                className=" h-[34px] px-3 border border-[#EF4444] rounded-md text-sm text-[#EF4444] "
              >
                Close
              </button>
            );
        },
      },
    ],
    []
  );

  const rejectColumns = useMemo(
    () => [
      {
        Header: "Job ID",
        width: 60,
        accessor: "job_id",
      },
      {
        Header: "Job Title",
        width: 150,
        accessor: "job_title",
        Cell: ({ row }) => (
          <>
            <Link
              style={{ color: "#2563EB", textDecoration: "underline" }}
              to={`/job-details/${row?.original?.job_id}`}
              state={{
                status: "REJECTED",
                create_time: row?.original?.create_time,
                reason: row?.original?.reject_reason,
                job_status: row?.original?.job_status,
              }}
            >
              <p data-tooltip-id={row?.original?.job_title}>
                {row?.original?.job_title?.length > 30
                  ? row?.original?.job_title?.slice(0, 30)
                  : row?.original?.job_title}{" "}
                {row?.original?.job_title?.length > 30 ? "...." : ""}
              </p>
            </Link>
            <ReactTooltip
              id={row?.original?.job_title}
              place="right"
              content={row?.original?.job_title}
            />
          </>
        ),
        linkAccessor: "link",
      },
      {
        Header: "Company Name",
        width: 150,
        accessor: "company.company_name",
        Cell: ({ row }) => (
          <>
            <p data-tooltip-id={row?.original?.company?.company_name}>
              {row?.original?.company?.company_name?.length > 30
                ? row?.original?.company?.company_name?.slice(0, 30)
                : row?.original?.company?.company_name}
              {row?.original?.company?.company_name?.length > 30 ? "...." : ""}
            </p>
            <ReactTooltip
              id={row?.original?.company?.company_name}
              place="right"
              content={row?.original?.company?.company_name}
            />
          </>
        ),
      },
      {
        Header: "Job Type",
        width: 120,
        accessor: "job_type_name",
      },
      {
        Header: "Compensation  Type",
        width: 130,
        accessor: "compensation_type",
      },
      {
        Header: "Compensation",
        width: 130,
        accessor: "compensation",
      },

      {
        Header: "Projected Earning",
        width: 120,
        accessor: "projected",
        Cell: ({ value }) => (value === null ? 0 : `₹ ${value}`),
      },
      {
        Header: "CTC/Stipend",
        width: 130,
        accessor: (row) => {
          if (row.job_type_name === "Full Time Job") {
            let max = Number(String(row?.ctc_max).slice(0, 2));
            let min = Number(String(row?.ctc_min).slice(0, 2));
            max = (row?.ctc_max < 1000000) ? parseFloat(max / 10) : max;
            min = (row?.ctc_min < 1000000) ? parseFloat(min / 10) : min;

            return `₹ ${min} - ${max}  LPA`;
          } else {
            const stipend = row?.stipend ?? 0.0;
            return `₹ ${stipend}`;
          }
        },
      },
      {
        Header: "Location",
        width: 120,
        accessor: (row) => {
          if (row.work_from_home) return "Work From Home";
          else return row.job_location;
        },
        Cell: ({ value, row }) => {
          if (value === "Work From Home")
            return (
              <div
                onClick={() =>
                  window.open(`/job-details/${row?.original?.job_id}`, "_blank")
                }
              >
                Work From Home
              </div>
            );
          else if (Array.isArray(value) && value?.length === 1)
            return (
              <div
                onClick={() => navigate(`/job-details/${row?.original?.job_id}`)}
              >
                {value[0]?.city}
              </div>
            );
          else {
            return (
              <div
                onClick={() =>
                  window.open(`/job-details/${row?.original?.job_id}`, "_blank")
                }
              >
                {`${value[0]?.city} , ${value[1]?.city} + ${value?.length > 2 ? value?.length - 2 : ""
                  }`}
              </div>
            );
          }
        },
      },
      {
        Header: "Assign Date",
        width: 130,
        accessor: "create_time",
      },
      {
        Header: "Assign By",
        width: 130,
        accessor: "assigned_by",
      },
      {
        Header: "Rejected date",
        width: 130,
        Cell: RedCell,
        accessor: "update_time",
      },
      {
        Header: "Rejected Reason",
        width: 130,
        Cell: ({ row }) => (
          <>
            <p
              className="text-sm font-medium text-[#EF4444] "
              data-tooltip-id={row?.original?.reject_reason}
            >
              {row?.original?.reject_reason?.length > 30
                ? row?.original?.reject_reason?.slice(0, 30)
                : row?.original?.reject_reason}{" "}
              {row?.original?.reject_reason?.length > 30 ? "....." : ""}
            </p>
            <ReactTooltip
              id={row?.original?.reject_reason}
              place="right"
              content={row?.original?.reject_reason}
            />
          </>
        ),
        accessor: "reject_reason",
      },
      {
        Header: " Action",
        // accessor: "action",
        Cell: ({ row }) => {
          if (row?.original?.job_status === "OPEN")
            return (
              <div>
                <button
                  className=" h-[34px] px-3 mr-2 bg-[#0DA06A] rounded-md text-sm text-white "
                  onClick={() => handleClickAccepted(row?.original)}
                >
                  {loadingAccepted ? <Spinner /> : "Accept"}
                </button>
              </div>
            );
          else
            return (
              <button
                // onClick={()=>{handleClickOpen(row.original)}}
                disabled={true}
                className=" h-[34px] px-3 border border-[#EF4444] rounded-md text-sm text-[#EF4444] "
              >
                Job Closed
              </button>
            );
        },
      },
    ],
    []
  );

  const DialogActions = (btnColor) => {
    return (
      <>
        {" "}
        <div className="grid grid-cols-2 gap-4 px-7 py-7 ">
          <div>
            <button
              type="button"
              className="w-full text-[#6C757D] border border-[#6C757D] rounded-md h-[40px]"
              onClick={handleClose}
            >
              Cancel
            </button>
          </div>
          <div>
            <button
              type="button"
              disabled={rejection?.disabled}
              className="w-full text-white rounded-md bg-[#EF4444] h-[40px] "
              onClick={handleClickRejected}
            >
              {loadingRejected ? <Spinner color="red" /> : "Submit"}
            </button>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="relative bg-[#f9fafb]">
        <div className=" sticky top-0 z-10 bg-[#f9fafb] ">
          <div className="mb-4 border-b-[2px] border-[#CBD5E1] ">
            <ul
              className="flex flex-wrap -mb-px text-sm font-medium text-center"
              id="myTab"
              data-tabs-toggle="#myTabContent"
              role="tablist"
            >
              <li
                className="mr-2"
                role="presentation"
                onClick={() => handleChange(1)}
              >
                <button
                  className={`inline-block p-4 pb-2  rounded-t-lg  hover:text-black ${value === 1
                    ? "text-black  font-bold  border-b-2 border-[#2563EB] "
                    : "text-[#6C757D]"
                    }`}
                  id="profile-tab"
                  data-tabs-target="#profile"
                  type="button"
                  role="tab"
                  aria-controls="profile"
                  aria-selected="false"
                >
                  My Job ({jobCount?.my_job_count})
                </button>
              </li>
              <li
                className="mr-2"
                role="presentation"
                onClick={() => handleChange(2)}
              >
                <button
                  className={`inline-block p-4 pb-2   rounded-t-lg  hover:text-black ${value === 2
                    ? "text-black  font-bold  border-b-2 border-[#2563EB] "
                    : "text-[#6C757D]"
                    }`}
                  data-tabs-target="#dashboard"
                  type="button"
                  role="tab"
                  aria-controls="dashboard"
                  aria-selected="false"
                >
                  New Job ({jobCount?.new_job_count})
                </button>
              </li>
              <li
                className="mr-2"
                role="presentation"
                onClick={() => handleChange(3)}
              >
                <button
                  className={`inline-block p-4 pb-2  rounded-t-lg  hover:text-black ${value === 3
                    ? "text-black  font-bold  border-b-2 border-[#2563EB] "
                    : "text-[#6C757D]"
                    }`}
                  data-tabs-target="#settings"
                  type="button"
                  role="tab"
                  aria-controls="settings"
                  aria-selected="false"
                >
                  Rejected Job ({jobCount?.rejected_job_count})
                </button>
              </li>
            </ul>
          </div>

          <div className="mt-6 mb-6 grid grid-cols-4 gap-4 ">
            <div>
              <SearchBox filter={filter} setFilter={setFilter} />
            </div>
            <div>
              <OptionInput
                placeholder="Job Type"
                data={typeData}
                filter={filter}
                setFilter={setFilter}
                value={value}
              />
            </div>{" "}
            <div>
              <OptionInput
                placeholder="Assign By"
                data={assigndata}
                filter={filter}
                setFilter={setFilter}
                value={value}
              />
            </div>
          </div>
        </div>
        <div id="myTabContent" className="">
          <div
            className={`${value === 1 ? "block " : "hidden"}  `}
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <JobTable
              columns={columns}
              data={myJobData?.results ?? []}
              paginationData={paginationData}
              setPaginationData={setPaginationData}
              tableWidth="w-full"
              pagination="pagination"
              loading={loading}
            />
          </div>
          <div
            className={` ${value === 2 ? "block" : "hidden"}  `}
            id="dashboard"
            role="tabpanel"
            aria-labelledby="dashboard-tab"
          >
            <JobTable
              columns={newJobcolumns}
              data={newJobData?.results ?? []}
              paginationData={paginationData}
              setPaginationData={setPaginationData}
              tableWidth="w-full"
              pagination="pagination"
              loading={loading}
            />
            <Dialog
              visible={open}
              title={"Are you sure you want to reject this job ?"}
              handleCloseDialog={handleClose}
              actionsPannel={DialogActions("bg-green")}
              size={"w-[420px]"}
              color={"bg-green"}
            >
              <div className="h-[200px]">
                <OptionInputReason
                  placeholder="Select Your Reason"
                  data={assignData}
                  filter={rejection}
                  setFilter={setRejection}
                />

                {rejection?.reasonDropDown?.id === 7 && (
                  <textarea
                    id="message"
                    rows="4"
                    className="block p-2.5 mt-5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
                    placeholder="Write your thoughts here..."
                    onChange={(e) =>
                      setRejection({
                        ...rejection,
                        disabled: false,
                        reasonTextBox: e.target.value,
                      })
                    }
                  />
                )}
              </div>
            </Dialog>
          </div>
          <div
            className={`  ${value === 3 ? "block" : "hidden"}  `}
            id="settings"
            role="tabpanel"
            aria-labelledby="settings-tab"
          >
            <JobTable
              columns={rejectColumns}
              data={reNewJobData?.results ?? []}
              paginationData={paginationData}
              setPaginationData={setPaginationData}
              tableWidth="w-full"
              pagination="pagination"
              loading={loading}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default AllJobsTab;

const assignData = [
  {
    id: 1,
    reason: "payout is less",
  },
  {
    id: 2,
    reason: "do not have relevant candidates",
  },
  {
    id: 3,
    reason: "not working for tech hiring",
  },
  {
    id: 4,
    reason: "not working for non tech hiring",
  },
  {
    id: 5,
    reason: "job details are not clear",
  },
  {
    id: 6,
    reason: "job is not looks profitable",
  },
  {
    id: 7,
    reason: "Other",
  },
];
